export class PlanType {
  static readonly None = new PlanType('')
  static readonly JuniorTabletCourse = new PlanType('9') // 小学コース
  static readonly TotalGuidancePlan = new PlanType('5') // 中学受験コース(トータル指導プラン)
  static readonly CramSchoolLearningPlan = new PlanType('4') // 中学受験コース(塾併用要点学習プラン)
  static readonly JuniorNCourse = new PlanType('10') // N本科
  static readonly JuniorNCourse13 = new PlanType('13') // N本科
  static readonly JuniorNCourse14 = new PlanType('14') // N本科
  static readonly ACourseAPlan = new PlanType('a') // 頻出分野別演習 国語 超長文
  static readonly ACourseBPlan = new PlanType('b') // 頻出分野別演習 国語 難関記述
  static readonly ACourseCPlan = new PlanType('c') // 頻出分野別演習 算数 立体図形難問
  static readonly ACourseDPlan = new PlanType('d') // 頻出分野別演習 算数 平面図形難問
  static readonly ACourseEPlan = new PlanType('e') // 頻出分野別演習 理科 論理的思考問題
  static readonly ACourseFPlan = new PlanType('f') // 頻出分野別演習 理科 複雑計算問題
  static readonly ACourseGPlan = new PlanType('g') // 頻出分野別演習 社会 文章記述
  static readonly ACourseHPlan = new PlanType('h') // 志望校別予想演習 筑波大附属駒場
  static readonly ACourseIPlan = new PlanType('i') // 志望校別予想演習 開成
  static readonly ACourseJPlan = new PlanType('j') // 志望校別予想演習 桜蔭
  static readonly ACourseKPlan = new PlanType('k') // 志望校別予想演習 神戸女学院
  static readonly ACourseLPlan = new PlanType('l') // 志望校別予想演習 灘
  static readonly ACourseMPlan = new PlanType('m') // 志望校別予想演習 甲陽学院
  static readonly NCourseWPlan = new PlanType('w') // 思考・表現力
  static readonly NCourseQPlan = new PlanType('q') // 作文
  static readonly NCourseVPlan = new PlanType('v') // 公立中高一貫校適性検査
  static readonly NCourseRPlan = new PlanType('r') // 公立中高一貫校作文

  readonly value: string

  static readonly AHonkaCourse = ['4', '5']
  static readonly NHonkaCourse = ['10', '13', '14']
  static readonly ASenkaCourse = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm']
  static readonly NSenkaCourse = ['w', 'q', 'v', 'r']

  private constructor(value: string) {
    this.value = value
  }

  static values(): PlanType[] {
    return [
      PlanType.None,
      PlanType.JuniorTabletCourse,
      PlanType.TotalGuidancePlan,
      PlanType.CramSchoolLearningPlan,
      PlanType.JuniorNCourse,
      PlanType.JuniorNCourse13,
      PlanType.JuniorNCourse14,
      PlanType.ACourseAPlan,
      PlanType.ACourseBPlan,
      PlanType.ACourseCPlan,
      PlanType.ACourseDPlan,
      PlanType.ACourseEPlan,
      PlanType.ACourseFPlan,
      PlanType.ACourseGPlan,
      PlanType.ACourseHPlan,
      PlanType.ACourseIPlan,
      PlanType.ACourseJPlan,
      PlanType.ACourseKPlan,
      PlanType.ACourseLPlan,
      PlanType.ACourseMPlan,
      PlanType.NCourseWPlan,
      PlanType.NCourseQPlan,
      PlanType.NCourseVPlan,
      PlanType.NCourseRPlan,
    ]
  }

  static convertPlanType(str: string): PlanType {
    const planType = PlanType.values().find(planType => planType.value === str)
    return planType || PlanType.None
  }

  isAHonkaCourse(): boolean {
    return PlanType.AHonkaCourse.includes(this.value)
  }

  isNHonkaCourse(): boolean {
    return PlanType.NHonkaCourse.includes(this.value)
  }

  isASenkaCourse(): boolean {
    return PlanType.ASenkaCourse.includes(this.value)
  }

  isNSenkaCourse(): boolean {
    return PlanType.NSenkaCourse.includes(this.value)
  }
}
